//是否显示头部
export const UPDATE_HEAD = 'UPDATE_HEAD';

//是否显示loading
export const UPDATE_LOADING = 'UPDATE_LOADING';

//是否显示footer
export const UPDATE_FOOTER = 'UPDATE_FOOTER';

//页面标题
export const UPDATE_PAGE_TITLE = 'UPDATE_PAGE_TITLE';

//授权过的用户信息
export const UPDATE_USERINFO = 'UPDATE_USERINFO';

//用户TOKEN，用于判断登录授权是否有效
export const UPDATE_TOKEN = 'UPDATE_TOKEN';
export const UPDATE_ROLES = 'UPDATE_ROLES';

//商户判断是否显示手机号验证，合作开关和反馈开关
export const UPDATE_PHONE = 'UPDATE_PHONE';
export const UPDATE_COOPER = 'UPDATE_COOPER';
export const UPDATE_FEEDBACK = 'UPDATE_FEEDBACK';
//618活动
export const UPDATE_ACTIVITY = 'UPDATE_ACTIVITY';

//云闪付用户唯一标识
export const UPDATE_OPENID = 'UPDATE_OPENID';

// 云闪付跳转授权记录
export const UNION_PAY_AUTH_FLAG = 'UNION_PAY_AUTH_FLAG';


export const UNION_FIX_EXIT_BUG_PATH = "UNION_FIX_EXIT_BUG_PATH";



// WEBPACK FOOTER //
// ./src/store/modules/consts.js